module.exports = __webpack_public_path__ + "img/19.1.A.a2f38e11.png";